export default __webpack_public_path__ + "static/media/has-photo.84b7cf02.svg";